import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Select } from "antd";
import AxiosInstance from "../../../AxiosInstance";

import { Controller, useForm } from "react-hook-form";
import { useMediaQuery } from "react-responsive";
import OtherPageHeader from "../../../components/OtherHeader";
import PartnerEntityRegistration from "./PartnerEntityRegistration";
import { TPEProfile } from "../../../svg/SvgImages";
import { Option } from "antd/es/mentions";
import {
  banksListController,
  countriesListController,
  insurerListController,
  statesListController,
} from "../../Helper/provider";
import { alertError } from "../../Helper/Alerts";
import { uploadProfileDocumentToAWS } from "../../Helper/uploadDocument";
import { getBankAccountType } from "../../../utils";
import {
  genderOptions,
  occupationOptions,
} from "../../../utils/dropDownOptions";
import { AllowedProfileEditStatus } from "../../../constants";
import { Button, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  documentAccpetedTypes,
  documentWidget,
  iDocumentStages,
} from "../../../utils/constants";
const PartnerRegistraionNew = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    getValues,
    reset,
  } = useForm({ mode: "onChange" });

  const navigate = useNavigate();
  const [panDoc, setpanDoc] = useState();
  const [aadharDoc, setaadharDoc] = useState();
  const [cancelledChecqDoc, setcancelledChecqDoc] = useState();
  const [insurer, setInsurer] = useState([]);
  const [countries, setCountries] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [existingUser, setExistingUser] = useState(false);
  const [profileData, setProfileData] = useState({});
  const { state } = useLocation();
  const [isCompany, setIsCompany] = useState(false);

  const [verifyPanModalState, setVerifyPanModalState] = useState(false);
  const [isPanVerified, setIsPanVerified] = useState(false);
  const [verifyAadhaarModalState, setVerifyAadhaarModalState] = useState(false);
  const [isAadhaarVerified, setIsAadhaarVerified] = useState(false);
  // const isMobile = useMediaQuery({ query: "(max-width: 750px)" });

  const [documentHill, setDocumentHill] = useState({
    panDoc: { status: iDocumentStages.NOT_PICKED, url: "", key: "panDoc" },
    aadharDoc: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "aadharDoc",
    },
    cancelledChecqDoc: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "cancelledChecqDoc",
    },
  });
  useEffect(() => {
    console.log("use Effect", documentHill);
  }, [documentHill]);

  useEffect(() => {
    getSpinnerData();
    getProfileDataNew();
  }, []);
  const occupationChange = (value) => {
    setValue("occupation", value);
  };
  const getProfileDataNew = async () => {
    let profileData = {};
    const result = await AxiosInstance()
      .get(`/user/me`)
      .catch((error) => {});
    profileData = result.data;
    setProfileData(result.data);
    if (profileData.userType === "ENTITY") {
      setIsCompany(true);
      return;
    }

    if (profileData) {
      console.log(profileData);
      if (profileData.insurerId) setValue("insurerId", profileData.insurerId);
      if (profileData.isPanVerified && profileData.pan) {
        // pan field will be disable only if pan number is also available
        setValue("pan", profileData.pan);
        setIsPanVerified(true);
        console.log("pan verified");
      }
      if (profileData.pan) {
        setValue("pan", profileData.pan);
      }
      if (profileData.isAadhaarVerified && profileData.aadhar) {
        // aadhaar field will be disable only if pan number is also available
        setIsAadhaarVerified(true);
      }
      if (profileData.aadhar) {
        setValue("aadhar", profileData.aadhar);
      }
      if (profileData.gender) setValue("gender", profileData.gender);
      if (profileData.address) setValue("address", profileData.address);
      if (profileData.occupation)
        setValue("occupation", profileData.occupation);
      if (profileData.city) setValue("city", profileData.city);
      if (profileData.countryId) {
        countryChange(profileData.countryId);
      }
      if (profileData.stateId) {
        stateChange(profileData.stateId);
      }
      if (profileData.pinCode) setValue("pinCode", profileData.pinCode);
      if (profileData.bankAccountNumber)
        setValue("bankAccountNumber", profileData.bankAccountNumber);
      if (profileData.bankId) {
        bankNameChange(profileData.bankId);
      }
      if (profileData.accountType) {
        accountTypeChange(profileData.accountType);
      }
      if (profileData.IFSCCode) setValue("IFSCCode", profileData.IFSCCode);
      if (profileData.UPICode) setValue("UPICode", profileData.UPICode);
      if (profileData.CKYCNumber)
        setValue("CKYCNumber", profileData.CKYCNumber);
      if (profileData.PANDocument)
        setValue("PANDocument", profileData.PANDocument);
      if (profileData.cancelledCheck)
        setValue("cancelledCheck", profileData.cancelledCheck);

      if (profileData.AADHARDocument)
        setValue("AADHARDocument", profileData.AADHARDocument);
    }
  };
  const getSpinnerData = async () => {
    const result = await insurerListController(true);
    setInsurer(result);
    const ctn = await countriesListController();
    setCountries(ctn);
    const bnk = await banksListController();
    setBankList(bnk);
    if (state?.payload) {
      const list = await statesListController(state.payload.countryId);
      setStateList(list);
    }
  };
  async function uploadHandler(key, userId, event) {
    setDocumentHill((prev) => ({
      ...prev,
      [key]: { ...prev[key], status: iDocumentStages.PICKED },
    }));
    console.log(documentHill);
    //upload document
    const result = await uploadProfileDocumentToAWS(
      event.target.files[0],
      userId
    );
    console.log("result", result);
    //if result then set the api result
    if (result !== null && result !== "undefined") {
      setDocumentHill((prev) => ({
        ...prev,
        [key]: {
          ...prev[key],
          status: iDocumentStages.UPLOADED,
          url: result,
        },
      }));
    } else {
      setDocumentHill((prev) => ({
        ...prev,
        [key]: { ...prev[key], status: iDocumentStages.UPLOAD_FAILED },
      }));
    }
  }

  async function handleDocumentNew(event, target) {
    const userId = localStorage.getItem("userId");
    switch (target) {
      case documentHill.panDoc.key:
        // set document for retry function
        setpanDoc(event);
        uploadHandler("panDoc", userId, event);

        break;
      case documentHill.aadharDoc.key:
        setaadharDoc(event);
        uploadHandler("aadharDoc", userId, event);

        break;
      default:
        setcancelledChecqDoc(event);
        uploadHandler("cancelledChecqDoc", userId, event);

        break;
    }
  }

  function iretryFunction(document) {
    if (documentHill.panDoc.key === document.key)
      handleDocumentNew(panDoc, documentHill.panDoc.key);
    else if (documentHill.aadharDoc.key === document.key)
      handleDocumentNew(aadharDoc, document.key);
    else if (documentHill.cancelledChecqDoc.key === document.key)
      handleDocumentNew(cancelledChecqDoc, document.key);
  }

  const genderChange = (value) => {
    errors.gender = false;
    setValue("gender", value);
  };
  const insurerChange = (insurerId) => {
    errors.insurerId = false;
    setValue("insurerId", parseInt(insurerId));
  };

  const countryChange = async (countryID) => {
    errors.countryId = false;
    setValue("countryId", parseInt(countryID));
    const list = await statesListController(countryID);
    setStateList(list);
  };
  const stateChange = (stateId) => {
    errors.stateId = false;
    setValue("stateId", parseInt(stateId));
  };
  const bankNameChange = (value) => {
    errors.bankId = false;
    setValue("bankId", parseInt(value));
  };
  const accountTypeChange = (type) => {
    errors.accountType = false;
    setValue("accountType", type);
  };
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });

  const onSubmit = async (value) => {
    console.log("Values.before upload..", value);
    const id = localStorage.getItem("id");
    if (documentHill.panDoc.status === iDocumentStages.UPLOADED)
      value.PANDocument = documentHill.panDoc.url;
    if (documentHill.aadharDoc.status === iDocumentStages.UPLOADED)
      value.AADHARDocument = documentHill.aadharDoc.url;
    if (documentHill.cancelledChecqDoc.status === iDocumentStages.UPLOADED)
      value.cancelledCheck = documentHill.cancelledChecqDoc.url;

    console.log("Values after upload...", value);
    if (state && state.payload) {
      AxiosInstance()
        .post("/auth/addNewRole", { userRole: "PARTNER" })
        .then((resp) => {
          localStorage.setItem("token", resp.data.token);
          AxiosInstance()
            .put("/profile", value)
            .then((resp) => {
              window.location.href = "/partnerDashboard";
            })
            .catch((err) => {
              alertError(err?.response?.data?.message);
            });
        })
        .catch((err) => {
          alertError(err?.response?.data?.message);
        });
      return;
    }
    AxiosInstance()
      .put("/profile", value)
      .then((resp) => {
        let { data } = resp;
        // localStorage.setItem("token", data.token);
        window.location.href = "/partnerDashboard";
      })
      .catch((err) => {
        alertError(err?.response?.data?.message);
      });
  };

  return (
    <div>
      <OtherPageHeader
        classProps="bg-transparent"
        innerClassProps="navbar-light"
      />
      <section className="section-preview py-3">
        <div className="container">
          <div className="row mx-1">
            {!isMobile && (
              <div className="col-md-5 mb-4 px-4 d-none d-md-block">
                <TPEProfile />
              </div>
            )}
            <div className="col-md-7 mb-4 px-4">
              <div className="common-width">
                <div className="flex d-flex justify-content-between">
                  <button
                    type="submit"
                    title="back-button"
                    className="back-button"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    {" "}
                    <i className="fa fa-angle-left" /> Back
                  </button>
                  {!profileData.isUserVerified && (
                    <button
                      type="submit"
                      disabled={profileData.isUserVerified}
                      // title="back-button"
                      className="back-button  "
                      onClick={() => {
                        setIsCompany(!isCompany);
                      }}
                    >
                      {" "}
                      Register as {isCompany ? "User" : "Company"}
                    </button>
                  )}
                </div>

                <h2 className="partner-complete-profile">
                  Complete your Profile
                </h2>
                {isCompany ? (
                  <PartnerEntityRegistration userData={profileData} />
                ) : (
                  <>
                    <form
                      id="completePartnerDetails"
                      onSubmit={handleSubmit(onSubmit)}
                    >
                      <div class="row my-3 ">
                        <h4 className="font-20 tre_font-bold">
                          Personal Details
                        </h4>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-6">
                          <div class="md-form">
                            <label for="insurer" class="">
                              Working With{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <Controller
                              name="insurerId"
                              control={control}
                              errors={errors}
                              rules={{ required: true }}
                              render={(props) => (
                                <Select
                                  className={`${
                                    errors.insurerId ? "is-invalid" : ""
                                  }`}
                                  value={getValues("insurerId")}
                                  disabled={
                                    profileData.insurerId &&
                                    !AllowedProfileEditStatus.includes(
                                      profileData.status
                                    )
                                  }
                                  placeholder="Select Insurer"
                                  onChange={insurerChange}
                                  size="large"
                                  style={{ width: "100%" }}
                                >
                                  {insurer.map((item) => (
                                    <Option
                                      key={item.insurerId}
                                      value={item.insurerId}
                                    >
                                      {item.name}
                                    </Option>
                                  ))}
                                </Select>
                              )}
                            />

                            <div className="invalid-feedback">
                              Insurer is required
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 md-form">
                          <label htmlFor="firstName">
                            Gender {<span style={{ color: "red" }}>*</span>}
                          </label>

                          <div className="input-group">
                            <Controller
                              name="gender"
                              control={control}
                              errors={errors}
                              rules={{ required: true }}
                              render={({ field: { onChange, value, ref } }) => (
                                <Select
                                  value={getValues("gender")}
                                  disabled={
                                    profileData.gender &&
                                    profileData.isUserVerified
                                  }
                                  onChange={genderChange}
                                  size="large"
                                  className={`${
                                    errors.gender ? "is-invalid" : ""
                                  }`}
                                  options={genderOptions}
                                  style={{ width: "100%" }}
                                />
                              )}
                            />

                            <div className="invalid-feedback">
                              Gender is required
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-md-6">
                          <div class="md-form">
                            <label for="pan" class="">
                              PAN No. {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <div className="input-group">
                              <input
                                disabled={isPanVerified}
                                type="text"
                                id="pan"
                                name="pan"
                                className={`form-control ${
                                  errors.pan ? " is-invalid" : ""
                                }`}
                                {...register("pan", {
                                  required: true,
                                })}
                              />
                              <div className="input-group-append">
                                {isPanVerified && (
                                  <span
                                    className="input-group-text  rounded-0 "
                                    id="basic-addon2"
                                  >
                                    <i class="fa-solid fa-circle-check text-success py-1 fa-lg"></i>
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="invalid-feedback">
                              Pan is required
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 md-form">
                          <label for="occupation" class="">
                            Occupation {<span style={{ color: "red" }}>*</span>}
                          </label>
                          <div className="input-group pb-3">
                            <Controller
                              name="occupation"
                              control={control}
                              errors={errors}
                              render={(props) => (
                                <Select
                                  className={`${
                                    errors.occupation ? "is-invalid" : ""
                                  }`}
                                  onChange={occupationChange}
                                  value={getValues("occupation")}
                                  disabled={
                                    profileData.occupation &&
                                    profileData.isUserVerified
                                  }
                                  size="large"
                                  style={{ width: "100%" }}
                                >
                                  {occupationOptions.map((item) => (
                                    <Option
                                      key={item.occupationId}
                                      value={item.occupationId}
                                    >
                                      {item.occupation}
                                    </Option>
                                  ))}
                                </Select>
                              )}
                            />
                            <div className="invalid-feedback">
                              {" "}
                              {errors?.occupation?.message}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-md-6">
                          <div class="md-form">
                            <label for="aadhar" class="">
                              Aadhar No.{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <input
                              disabled={isAadhaarVerified}
                              type="text"
                              id="aadhar"
                              name="aadhar"
                              className={`form-control ${
                                errors.aadhar ? " is-invalid" : ""
                              }`}
                              {...register("aadhar", {
                                required: true,
                                pattern: {
                                  value: /^[0-9]*$/i,
                                  message: "invalid value",
                                },
                              })}
                            />
                            <div className="invalid-feedback">
                              Aadhar is required
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="md-form">
                            <label for="address" class="">
                              Current Address{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <input
                              type="text"
                              id="address"
                              name="address"
                              disabled={
                                profileData.address &&
                                profileData.isUserVerified
                              }
                              className={`form-control ${
                                errors.address ? " is-invalid" : ""
                              }`}
                              {...register("address", {
                                required: true,
                              })}
                            />
                            <div className="invalid-feedback">
                              Address is required
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-md-6">
                          <div class="md-form">
                            <label for="countryId" class="">
                              Country {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <Controller
                              name="countryId"
                              control={control}
                              errors={errors}
                              rules={{ required: true }}
                              render={(props) => (
                                <Select
                                  className={`${
                                    errors.countryId ? "is-invalid" : ""
                                  }`}
                                  value={getValues("countryId")}
                                  disabled={
                                    profileData.countryId &&
                                    profileData.isUserVerified
                                  }
                                  onChange={countryChange}
                                  size="large"
                                  style={{ width: "100%" }}
                                >
                                  {countries.map((item) => (
                                    <Option
                                      key={item.countryId}
                                      value={item.countryId}
                                    >
                                      {item.name}
                                    </Option>
                                  ))}
                                </Select>
                              )}
                            />

                            <div className="invalid-feedback">
                              Country is required
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="md-form">
                            <label for="state" class="">
                              State {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <Controller
                              name="stateId"
                              control={control}
                              errors={errors}
                              rules={{ required: true }}
                              render={(props) => (
                                <Select
                                  className={`${
                                    errors.stateId ? "is-invalid" : ""
                                  }`}
                                  value={getValues("stateId")}
                                  disabled={
                                    profileData.stateId &&
                                    profileData.isUserVerified
                                  }
                                  onChange={stateChange}
                                  size="large"
                                  style={{ width: "100%" }}
                                >
                                  {stateList.map((item) => (
                                    <Option
                                      key={item.stateId}
                                      value={item.stateId}
                                    >
                                      {item.name}
                                    </Option>
                                  ))}
                                </Select>
                              )}
                            />

                            <div className="invalid-feedback">
                              State is required
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-md-6">
                          <div class="md-form">
                            <label for="city" class="">
                              City {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <input
                              disabled={
                                profileData.city && profileData.isUserVerified
                              }
                              type="text"
                              id="city"
                              name="city"
                              className={`form-control ${
                                errors.city ? " is-invalid" : ""
                              }`}
                              {...register("city", {
                                required: true,
                              })}
                            />
                            <div className="invalid-feedback">
                              City is required
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="md-form">
                            <label for="pinCode" class="">
                              Pin Code {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <input
                              disabled={
                                profileData.pinCode &&
                                profileData.isUserVerified
                              }
                              type="text"
                              id="pinCode"
                              name="pinCode"
                              className={`form-control ${
                                errors.pinCode ? " is-invalid" : ""
                              }`}
                              {...register("pinCode", {
                                required: true,
                              })}
                            />
                            <div className="invalid-feedback">
                              Pincode is required
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-6">
                          <div class="md-form">
                            {/* <label for="trePartnerpAddress" class="">
                          Parmanent Address
                        </label>
                        <input
                          type="text"
                          id="trePartnerpAddress"
                          name="trePartnerpAddress"
                          class="form-control"
                        /> */}
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="md-form"></div>
                        </div>
                      </div>
                      <div class="row my-3">
                        <h4 className="font-20 tre_font-bold">
                          Banking Details
                        </h4>
                      </div>

                      <div class="row mb-3">
                        <div class="col-md-6">
                          <div class="md-form">
                            <label for="bankAccountNumber" class="">
                              Bank Account Number{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <input
                              disabled={
                                profileData.bankAccountNumber &&
                                profileData.isUserVerified
                              }
                              type="text"
                              id="bankAccountNumber"
                              placeholder=""
                              className={`form-control ${
                                errors.bankAccountNumber ? " is-invalid" : ""
                              }`}
                              {...register("bankAccountNumber", {
                                required: true,
                              })}
                            />
                            <div className="invalid-feedback">
                              Account Number is required
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="md-form">
                            <label htmlFor="bankName">
                              Bank Name{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <div className="input-group">
                              <Controller
                                name="bankId"
                                control={control}
                                errors={errors}
                                rules={{ required: true }}
                                render={(props) => (
                                  <Select
                                    className={`${
                                      errors.bankId ? "is-invalid" : ""
                                    }`}
                                    disabled={
                                      profileData.bankId &&
                                      profileData.isUserVerified
                                    }
                                    value={getValues("bankId")}
                                    onChange={bankNameChange}
                                    size="large"
                                    style={{ width: "100%" }}
                                  >
                                    {bankList.map((item) => (
                                      <Option
                                        key={item.bankId}
                                        value={item.bankId}
                                      >
                                        {item.name}
                                      </Option>
                                    ))}
                                  </Select>
                                )}
                              />

                              <div className="invalid-feedback">
                                Bank Name is required
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-md-6">
                          <div class="md-form">
                            <label htmlFor="accountType">
                              Account Type{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <Controller
                              name="accountType"
                              control={control}
                              errors={errors}
                              rules={{ required: true }}
                              render={(props) => (
                                <Select
                                  className={`${
                                    errors.accountType ? "is-invalid" : ""
                                  }`}
                                  disabled={
                                    profileData.accountType &&
                                    profileData.isUserVerified
                                  }
                                  value={getValues("accountType")}
                                  onChange={accountTypeChange}
                                  size="large"
                                  style={{ width: "100%" }}
                                >
                                  {getBankAccountType()}
                                </Select>
                              )}
                            />

                            <div className="invalid-feedback">
                              Account Type is required
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="md-form">
                            <label for="CKYCNumber" class="">
                              CKYC No.
                            </label>
                            <input
                              disabled={
                                profileData.CKYCNumber &&
                                !AllowedProfileEditStatus.includes(
                                  profileData.status
                                )
                              }
                              type="text"
                              id="CKYCNumber"
                              name="CKYCNumber"
                              class="form-control"
                              {...register("CKYCNumber", {})}
                            />
                          </div>
                          {/* <div class="md-form">
                        <label htmlFor="MICR ">MICR</label>
                        <input
                          type="text"
                          id="MICR"
                          name="MICR"
                          className={`form-control ${
                            errors.MICR ? " is-invalid" : ""
                          }`}
                          {...register("MICR", {
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          MICR Code is required
                        </div>
                      </div> */}
                        </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-md-6">
                          <div class="md-form">
                            <label for="IFSCCode" class="">
                              IFSC Code{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <input
                              disabled={
                                profileData.IFSCCode &&
                                profileData.isUserVerified
                              }
                              type="text"
                              id="IFSCCode"
                              name="IFSCCode"
                              className={`form-control ${
                                errors.IFSCCode ? " is-invalid" : ""
                              }`}
                              {...register("IFSCCode", {
                                required: true,
                              })}
                            />
                            <div className="invalid-feedback">
                              IFSC Code is required
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="md-form">
                            <label for="UPICode" class="">
                              UPI Id
                            </label>
                            <input
                              disabled={
                                profileData.UPICode &&
                                !AllowedProfileEditStatus.includes(
                                  profileData.status
                                )
                              }
                              type="text"
                              id="UPICode"
                              name="UPICode"
                              class="form-control"
                              {...register("UPICode", {})}
                            />
                          </div>
                        </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-md-6"></div>
                        <div class="col-md-6">
                          {/* <div class="md-form">
                        <label for="EIANumber" class="">
                          EIA No.
                        </label>
                        <input
                          type="text"
                          id="EIANumber"
                          name="EIANumber"
                          class="form-control"
                          {...register("EIANumber", {})}
                        />
                      </div> */}
                        </div>
                      </div>

                      <div class="row my-3">
                        <h4 className="font-20 tre_font-bold">
                          Attachment Doc
                        </h4>
                      </div>

                      {!profileData.PANDocument && (
                        <div className="mb-3 mt-2">
                          <label htmlFor="formFile" className="form-label">
                            Upload Pan{" "}
                            <>
                              {documentWidget(
                                documentHill.panDoc,
                                iretryFunction
                              )}
                            </>
                          </label>
                          <input
                            className="form-control"
                            type="file"
                            accept={documentAccpetedTypes}
                            id="panDocument"
                            onChange={(event) => {
                              console.log("dfsfd");
                              handleDocumentNew(event, documentHill.panDoc.key);
                            }}
                          />
                        </div>
                      )}

                      {!profileData.AADHARDocument && (
                        <div className="mb-3">
                          <label htmlFor="formFile" className="form-label">
                            Upload Aadhar{" "}
                            <>
                              {documentWidget(
                                documentHill.aadharDoc,
                                iretryFunction
                              )}
                            </>
                          </label>
                          <input
                            className="form-control"
                            type="file"
                            id="aadharDocument"
                            accept={documentAccpetedTypes}
                            onChange={(event) => {
                              handleDocumentNew(
                                event,
                                documentHill.aadharDoc.key
                              );
                              // handleDocument(event, "aadharDocument");
                            }}
                          />
                        </div>
                      )}
                      {!profileData.cancelledCheck && (
                        <div className="mb-3">
                          <label
                            htmlFor="cancellsedCheck"
                            className="form-label"
                          >
                            Upload Cancelled Cheque{" "}
                            <>
                              {documentWidget(
                                documentHill.cancelledChecqDoc,
                                iretryFunction
                              )}
                            </>
                          </label>
                          <input
                            className="form-control"
                            type="file"
                            id="cancelledCheck"
                            accept={documentAccpetedTypes}
                            onChange={(event) => {
                              handleDocumentNew(
                                event,
                                documentHill.cancelledChecqDoc.key
                              );
                              // handleDocument(event, "");
                            }}
                          />
                        </div>
                      )}
                    </form>
                    <button
                      className="btn-block btn-holder btn-md mb-5"
                      form="completePartnerDetails"
                    >
                      Complete Profile
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PartnerRegistraionNew;
